
const en = {
    successfulMessage: 'Your ad was added successfully!',
    wrongMessage: 'Something wrong, please try again',
}

const rus = {
    successfulMessage: 'Объявление успешно добавлено!',
    wrongMessage: 'Что-то пошло не так, попробуйте еще раз',
}

const hebrew = {
    successfulMessage: 'המודעה נוספה בהצלחה!',
    wrongMessage: 'משהו השתבש, אנא נסה שוב',
}

const choose = { en, rus, hebrew };

export default choose;